/* eslint-disable import/prefer-default-export */

export const PROFILE_DRAWER_LIST_UPDATE = 'PROFILE_DRAWER_LIST_UPDATE';
export const PROFILE_DRAWER_UPDATE = 'PROFILE_DRAWER_UPDATE';
export const FILTER_UPDATE = 'FILTER_UPDATE';
export const PROFILE_DRAWER_STATUS_UPDATE = 'PROFILE_DRAWER_STATUS_UPDATE';
export const SELECTED_PROFILE_DRAWER_UPDATE = 'SELECTED_PROFILE_DRAWER_UPDATE';
